<template>
	<div class="login-page">
		<!-- 背景装饰 -->
		<div class="bg-decoration"></div>

		<!-- 登录卡片 -->
		<div class="login-card">
			<div class="login-header">
				<h2 class="login-title">系统登录</h2>
				<p class="login-desc">欢迎使用海米文化信息管理系统</p>
			</div>

			<!-- 登录表单 -->
			<el-form
				:model="loginForm"
				:rules="loginRules"
				ref="loginFormRef"
				class="login-form"
			>
				<el-form-item prop="username">
					<el-input
						v-model="loginForm.username"
						placeholder="请输入用户名"
						prefix-icon="el-icon-user"
						class="input-item"
						size="large"
					/>
				</el-form-item>

				<el-form-item prop="password">
					<el-input
						v-model="loginForm.password"
						type="password"
						placeholder="请输入密码"
						prefix-icon="el-icon-lock"
						class="input-item"
						size="large"
						@keyup.enter="handleLogin"
					/>
				</el-form-item>
				<el-form-item class="login-btn-item">
					<el-button
						type="primary"
						class="login-btn"
						size="large"
						@click="handleLogin"
						:loading="isLoading"
					>
						登录系统
					</el-button>
				</el-form-item>
			</el-form>

			<!-- 底部版权 -->
			<div class="login-footer">
				<span>海米文化 版权所有</span>
			</div>
			<Vcode :show="isShow" @fail="fail" @success="onSuccess" @close="onClose" />
		</div>
	</div>
</template>

<script>
import {defineComponent} from 'vue';
import Vcode from "vue3-puzzle-vcode";
import { mapState, mapMutations } from "vuex";
import {ElButton, ElCheckbox, ElForm, ElFormItem, ElInput, ElMessage} from 'element-plus';


export default defineComponent({
	name: 'Login',
	components: {
		ElForm,
		ElFormItem,
		ElInput,
		ElButton,
		ElCheckbox,
		Vcode
	},
	data() {
		return {
			loginFormRef:  null,
			isLoading: false,
			loginForm: {
				username: '',
				password: '',
			},
			loginRules: {
				username: [
					{required: true, message: '请输入用户名', trigger: 'blur'},
					{min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur'}
				],
				password: [
					{required: true, validator: this.checkAge, trigger: 'blur'},
				]
			},
			isShow: false
		}
	},
	methods: {
		...mapMutations(["setSaToken"]),
		checkAge(rule, value, callback) {
			if (typeof value !== 'string') return callback(new Error('密码必须为字符串'));
			if (value.length < 8) return callback(new Error('密码长度不能少于8位'));
			if (!/[A-Z]/.test(value)) return callback(new Error('密码必须包含大写字母'));
			if (!/[a-z]/.test(value)) return callback(new Error('密码必须包含小写字母'));
			if (!/\d/.test(value)) return callback(new Error('密码必须包含数字'));
			if (!/[!@#$%^&*()_+\-=\[\]{}|;':",./<>?]/.test(value)) return callback(new Error('密码必须包含特殊符号'));
			callback();
		},
		handleLogin(data) {
			this.$refs.loginFormRef.validate((valid, fields) => {
				if (valid) {
					this.isShow = true;
				} else {
					console.log('错误的提交!', fields)
				}
			})

		},
		onSuccess() {
			$post('/admin/login', this.loginForm).then(res => {
				if (res.code === 200) {
					this.onClose();
					this.setSaToken(res.data.token);
					ElMessage.success('登录成功');
					// 这里可以添加路由跳转逻辑
					this.$router.push('/index');
				} else {
					this.onClose();
					ElMessage.error(res.message || '登录失败');
				}
			}).finally(() => {
				this.onClose();
			});
		},
		onClose() {
			this.isShow = false;
		},
		fail() {
			this.loginForm.password = "";
			this.onClose();
		}
	},
});
</script>

<style lang="scss" scoped>
.login-page {
	width: 100vw;
	height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	overflow: hidden;

	.bg-decoration {
		position: absolute;
		width: 100%;
		height: 100%;
		background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
		opacity: 0.3;
	}

	.login-card {
		width: 420px;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(31, 38, 135, 0.2);
		backdrop-filter: blur(8px);
		padding: 40px;
		position: relative;
		z-index: 10;

		.login-header {
			text-align: center;
			margin-bottom: 30px;

			.login-title {
				font-size: 24px;
				font-weight: 600;
				color: #2d3748;
				margin: 0 0 8px 0;
			}

			.login-desc {
				font-size: 14px;
				color: #718096;
				margin: 0;
			}
		}

		.login-form {
			width: 100%;

			.input-item {
				--el-input-border-radius: 8px;
				--el-input-hover-border-color: #667eea;
				--el-input-focus-border-color: #667eea;
				margin-bottom: 2px;
			}

			.form-row {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;

				.remember-checkbox {
					--el-checkbox-label-color: #4a5568;
					font-size: 13px;
				}

				.forgot-password {
					font-size: 13px;
					color: #667eea;
					cursor: pointer;
					transition: color 0.3s;

					&:hover {
						color: #5a67d8;
						text-decoration: underline;
					}
				}
			}

			.login-btn-item {
				margin-bottom: 0;

				.login-btn {
					width: 100%;
					height: 48px;
					border-radius: 8px;
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					border: none;
					font-size: 16px;
					font-weight: 500;

					&:hover {
						background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
					}
				}
			}
		}

		.login-footer {
			text-align: center;
			margin-top: 20px;
			padding-top: 20px;
			border-top: 1px solid #e2e8f0;

			span {
				font-size: 12px;
				color: #a0aec0;
			}
		}
	}
}
</style>
